import { Box, ImageListItem, Button, Modal, Typography } from "@mui/material";
import React from "react";
import QRCode from "react-qr-code";

const ImgPreviewModal = ({ buttonsArray, imageObj }) => {
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "2px",
  };

  const imgStyle = {
    maxHeight: "90vh",
    maxWidth: "100%",
  };
  return (
    <Modal
      open={imageObj.open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <ImageListItem sx={modalStyle}>
        {imageObj.type === "charger" ? (
          <>
            <Typography variant="h5" sx={{marginBottom:1}} >{ `CHARGER - ${imageObj.value}`}</Typography>
            <QRCode
              id={`chargerqr-${imageObj.value}`}
              value={`${imageObj.templateVal}${imageObj.value}`}
              style={imgStyle}
            />
          </>
        ) : imageObj.type === "upi" ? (
          <>
            <Typography variant="h5" sx={{marginBottom:1}}>UPI QR Code</Typography>
            {imageObj.value ? (
              <Box 
                id={`upiqr-${imageObj.value.replace(/[^a-zA-Z0-9]/g, '')}`}
                sx={{ 
                  position: 'relative',
                  display: 'flex', 
                  justifyContent: 'center', 
                  alignItems: 'center',
                  backgroundColor: '#ffffff',
                  padding: 2,
                  borderRadius: 2,
                  width: '100%'
                }}
              >
                <QRCode
                  value={imageObj.value}
                  style={imgStyle}
                />
                {imageObj.logoUrl && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      backgroundColor: '#ffffff',
                      padding: 1,
                      borderRadius: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    }}
                  >
                    <Box
                      component="img"
                      src={imageObj.logoUrl}
                      alt="Company Logo"
                      onError={(e) => {
                        e.target.style.display = 'none';
                      }}
                      sx={{
                        maxWidth: '60px',
                        maxHeight: '60px',
                        width: 'auto',
                        height: 'auto',
                        objectFit: 'contain',
                      }}
                    />
                  </Box>
                )}
              </Box>
            ) : (
              <Typography variant="body2" color="text.secondary">
                No UPI data available
              </Typography>
            )}
          </>
        ) : (
          <img
            style={imgStyle}
            src={`${
              imageObj.value
              ? imageObj.value instanceof File
              ? URL.createObjectURL(imageObj.value)
              : imageObj.value
              : ""
            }`}
            alt="img"
          />
        )}
        <Box sx={{ mt: 1 }}>
          {buttonsArray.length > 0 &&
            buttonsArray.map((buttonObj,index) => (
              <Button
                onClick={() => {
                  if (buttonObj.params) buttonObj.action(imageObj.value);
                  else buttonObj.action();
                }}
                key={`${index}-qr-${imageObj.type}`}
              >
                {buttonObj.btnLabel}
              </Button>
            ))}
        </Box>
      </ImageListItem>
    </Modal>
  );
};

export default ImgPreviewModal;
